import { HTTPError } from "ky";
import { AjaxError } from "../ajax-error";

export class ForbiddenException extends AjaxError {
  constructor(
    response: Response,
    request: Request,
    options: HTTPError["options"]
  ) {
    super(403, response, request, options);
    this.name = "ForbiddenException";
  }

  getUserFriendlyMessage(): string {
    return this.message || "Accesso negato. Non hai i permessi necessari per questa operazione.";
  }
}